import { acquisitionFailureDescriber } from '../acquisitionErrors';
import { PRESTITO_INELIGIBILITY_MESSAGE } from './prestitoEligibility';

export const PRESTITO_GENERIC_FAILURE_MESSAGE =
  'Non è stato possibile acquisire la lead Prestito. I dati inseriti sono stati conservati: riprova.';

/**
 * Translates a refused Prestito acquisition into what the operator reads: the
 * shared classification of acquisition failures, spoken in this product's own
 * words and explained with this product's own qualification policy.
 */
export const describePrestitoAcquisitionFailure = acquisitionFailureDescriber({
  leadLabel: 'Prestito',
  ineligibilityMessages: PRESTITO_INELIGIBILITY_MESSAGE,
  ineligibleFallback:
    'Il profilo del cliente non è idoneo per un Prestito e la lead non è stata acquisita.',
  genericFailure: PRESTITO_GENERIC_FAILURE_MESSAGE,
});
